export default "<div ng-transclude>\n</div>"